<template>
  <div id="app">
    <CcCountsCalendarS />
  </div>
</template>

<script>
import CcCountsCalendarS from './components/CcCountsCalendarS.vue'

export default {
  name: 'app',
  components: {
    CcCountsCalendarS
  }
}

</script>

<style>

</style>
